import * as amplitude from "@amplitude/analytics-browser";

import { RedeemType } from "components/Redeem/redeemTypes";

export const trackRedemptionStarted = () => {
  amplitude?.track("Redeem: redemption started", {
    "event source": "literati-next-kids",
    path: window.location.pathname,
    url: window.location.href,
  });
};

export const trackCodeRedeemed = (redeemType: RedeemType) => {
  amplitude?.track("Redeem: code redeemed", {
    "redemption type": redeemType,
    "event source": "literati-next-kids",
    path: window.location.pathname,
    url: window.location.href,
  });
};

export const trackGiftSubscriptionActivated = () => {
  amplitude?.track("Redeem: gift subscription activated", {
    "event source": "literati-next-kids",
    path: window.location.pathname,
    url: window.location.href,
  });
};
